import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './ServiceDetailPage.css';

const ServiceDetailPage = () => {
  const { serviceId } = useParams();

  // Service data
  const services = {
    'turnkey-sports-infrastructure': {
      title: 'Turnkey Sports Infrastructure',
      image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&h=500&fit=crop&crop=center',
      description: 'Complete sports facility development from planning to execution',
      details: [
        'End-to-end sports infrastructure development',
        'Project planning and design consultation',
        'Construction and installation services',
        'Quality assurance and testing',
        'Maintenance and support services',
        'Compliance with international standards'
      ],
      features: [
        'Custom facility design',
        'Professional project management',
        'Timely delivery guarantee',
        'Post-construction support',
        'Equipment procurement and installation',
        'Safety and compliance certification'
      ]
    },
    'project-consultation': {
      title: 'Project Consultation',
      image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=500&fit=crop&crop=center',
      description: 'Expert guidance for your sports infrastructure projects',
      details: [
        'Strategic planning and feasibility studies',
        'Technical design and engineering support',
        'Budget planning and cost optimization',
        'Timeline development and project scheduling',
        'Risk assessment and mitigation strategies',
        'Stakeholder coordination and management'
      ],
      features: [
        'Expert consultation services',
        'Comprehensive project analysis',
        'Customized solutions',
        'Industry best practices',
        'Cost-effective recommendations',
        'Ongoing project support'
      ]
    },
    'sports-flooring-solutions': {
      title: 'Sports Flooring Solutions',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=500&fit=crop&crop=center',
      description: 'Professional flooring for all sports and activities',
      details: [
        'Multi-sport flooring systems',
        'Indoor and outdoor solutions',
        'Shock absorption and safety features',
        'Durability and weather resistance',
        'Easy maintenance and cleaning',
        'Custom color and design options'
      ],
      features: [
        'High-performance materials',
        'Professional installation',
        'Warranty coverage',
        'Maintenance support',
        'Custom specifications',
        'International quality standards'
      ]
    },
    'sports-consultancy': {
      title: 'Sports Consultancy',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=500&fit=crop&crop=center',
      description: 'Strategic advice for sports organizations and facilities',
      details: [
        'Organizational development and strategy',
        'Facility management optimization',
        'Performance enhancement programs',
        'Technology integration solutions',
        'Training and development programs',
        'Compliance and regulatory guidance'
      ],
      features: [
        'Expert advisory services',
        'Customized solutions',
        'Industry expertise',
        'Proven methodologies',
        'Ongoing support',
        'Performance metrics'
      ]
    },
    'ground-development': {
      title: 'Ground Development',
      image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&h=500&fit=crop&crop=center',
      description: 'Complete ground development and infrastructure solutions',
      details: [
        'Site preparation and excavation',
        'Drainage and irrigation systems',
        'Surface preparation and leveling',
        'Grass and turf installation',
        'Lighting and electrical systems',
        'Maintenance and upkeep services'
      ],
      features: [
        'Professional ground preparation',
        'Quality materials and equipment',
        'Expert installation teams',
        'Comprehensive project management',
        'Long-term maintenance support',
        'Performance guarantees'
      ]
    },
    'physiology': {
      title: 'Physiology',
      image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&h=500&fit=crop&crop=center',
      description: 'Sports physiology and performance optimization',
      details: [
        'Athlete performance assessment',
        'Physiological testing and analysis',
        'Training program optimization',
        'Recovery and regeneration protocols',
        'Nutrition and hydration guidance',
        'Injury prevention strategies'
      ],
      features: [
        'Scientific approach to training',
        'Individualized programs',
        'Performance monitoring',
        'Expert guidance',
        'Evidence-based methods',
        'Continuous improvement'
      ]
    },
    'sports-games-training': {
      title: 'Sports & Games Training',
      image: 'https://images.unsplash.com/photo-1544717297-fa95b6ee9643?w=800&h=500&fit=crop&crop=center',
      description: 'Professional training and coaching for all sports',
      details: [
        'Multi-sport training programs',
        'Individual and team coaching',
        'Skill development and technique training',
        'Physical conditioning programs',
        'Mental training and sports psychology',
        'Competition preparation and strategy'
      ],
      features: [
        'Qualified coaching staff',
        'Modern training facilities',
        'Personalized training plans',
        'Progress tracking',
        'Competition opportunities',
        'Holistic development approach'
      ]
    },
    'admission': {
      title: 'Admission',
      image: 'https://stjameschurchschool.com/wp-content/uploads/2023/12/Admission.jpg',
      description: 'School and college admission assistance',
      details: [
        'Admission process guidance',
        'Application form assistance',
        'Document preparation support',
        'Interview preparation',
        'Scholarship and financial aid guidance',
        'Educational pathway planning'
      ],
      features: [
        'Expert admission counselors',
        'Comprehensive guidance',
        'Application support',
        'Interview preparation',
        'Financial aid assistance',
        'Success guarantee'
      ]
    },
    'scholarship': {
      title: 'Scholarship',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=500&fit=crop&crop=center',
      description: 'Sports scholarships and financial assistance',
      details: [
        'Scholarship identification and application',
        'Financial aid guidance',
        'Merit-based opportunities',
        'Need-based assistance',
        'Sports-specific scholarships',
        'Application process support'
      ],
      features: [
        'Comprehensive scholarship database',
        'Application assistance',
        'Financial planning support',
        'Expert guidance',
        'Success tracking',
        'Ongoing support'
      ]
    },
    'coaches': {
      title: 'Coaches',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=500&fit=crop&crop=center',
      description: 'Professional coaching platform and services',
      details: [
        'Coach recruitment and placement',
        'Professional development programs',
        'Certification and training',
        'Performance evaluation',
        'Career advancement support',
        'Networking and opportunities'
      ],
      features: [
        'Qualified coaching staff',
        'Professional development',
        'Career opportunities',
        'Training programs',
        'Performance support',
        'Industry connections'
      ]
    },
    'physiotherapy': {
      title: 'Physiotherapy',
      image: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=800&h=500&fit=crop&crop=center',
      description: 'Sports injury treatment and rehabilitation',
      details: [
        'Injury assessment and diagnosis',
        'Treatment and rehabilitation programs',
        'Prevention strategies',
        'Recovery optimization',
        'Performance enhancement',
        'Long-term health maintenance'
      ],
      features: [
        'Licensed physiotherapists',
        'Modern treatment facilities',
        'Personalized care plans',
        'Evidence-based treatments',
        'Recovery tracking',
        'Prevention programs'
      ]
    },
    'recruitment-jobs': {
      title: 'Recruitment & Jobs',
      image: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=800&h=500&fit=crop&crop=center',
      description: 'Sports industry job opportunities and recruitment',
      details: [
        'Job placement services',
        'Career counseling and guidance',
        'Resume and interview preparation',
        'Industry networking opportunities',
        'Professional development',
        'Career advancement support'
      ],
      features: [
        'Extensive job database',
        'Career guidance',
        'Interview preparation',
        'Professional networking',
        'Skill development',
        'Career advancement'
      ]
    },
    'sports-nutrition': {
      title: 'Sports Nutrition',
      image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&h=500&fit=crop&crop=center',
      description: 'Professional sports nutrition and diet planning',
      details: [
        'Nutritional assessment and analysis',
        'Customized meal planning',
        'Performance nutrition strategies',
        'Hydration optimization',
        'Supplement guidance',
        'Recovery nutrition protocols'
      ],
      features: [
        'Licensed nutritionists',
        'Personalized meal plans',
        'Performance optimization',
        'Evidence-based guidance',
        'Ongoing support',
        'Results tracking'
      ]
    },
    'online-offline': {
      title: 'Online & Offline Classes',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWF1N0YFNxDkejxXjhBmo4V0DRm04TnRxTEg&s',
      description: 'Online and offline sports coaching with expert training',
      details: [
        'Online and offline coaching options',
        'Expert guidance for all sports',
        'Skill-based personalized training',
        'Flexible class timings available',
        'Live interactive practice sessions',
        'Progress tracking and feedback'
      ],
      features: [
        'Certified sports coaches',
        'Personalized training plans',
        'Skill and fitness enhancement',
        'Technique-focused sessions',
        'Continuous mentor support',
        'Regular performance tracking'
      ]
    },
    'event-management': {
      title: 'Event Management',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSK-lspxlZRluDuxDoOAOXoXclf-faCdi4R9w&s',
      description: 'Expert event management with seamless planning and support',
      details: [
        'End-to-end planning for all event types',
        'Creative concepts and theme development',
        'On-site coordination and management',
        'Vendor sourcing and budget handling',
        'Logistics, scheduling, and execution',
        'Smooth guest experience and support'
      ],
      features: [
        'Professional event planners',
        'Customized event solutions',
        'Reliable vendor partnerships',
        'High-quality production setup',
        'Real-time coordination support',
        'Timely and seamless execution'
      ]

    },
    'domastic-international': {
      title: 'Domastic & International Sports Tour Program',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcStXi3slAinNVuSgWCDqcR5_6xI_avfOQv_dQ&s',
      description: 'Domestic and international sports tours with complete planning and support',
      details: [
        'Fully organized national and international sports tours',
        'Travel, stay, and venue arrangements for teams and athletes',
        'Professionally curated itineraries for training and matches',
        'On-ground assistance and dedicated tour coordinators',
        'Safe transportation and comfortable accommodation options',
        'End-to-end management for a smooth travel experience'
      ],
      features: [
        'Expert sports tour coordinators',
        'Customized travel and training packages',
        'Secure and comfortable travel arrangements',
        'Partnerships with trusted hotels and venues',
        '24/7 support throughout the tour',
        'Well-structured schedules for optimal performance'
      ]
    }
  };

  const service = services[serviceId];

  if (!service) {
    return (
      <div className="service-detail-page">
        <div className="container">
          <div className="error-content">
            <h1>Service Not Found</h1>
            <p>The requested service could not be found.</p>
            <Link to="/services" className="back-btn">Back to Services</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="service-detail-page">
      {/* Hero Section */}
      <section className="service-hero" style={{
        backgroundImage: `url(${service.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="service-hero-overlay"></div>
        <div className="container">
          <div className="service-hero-content">
            <h1 className="service-hero-title">{service.title}</h1>
            <p className="service-hero-description">{service.description}</p>
            <Link to="/services" className="back-btn">← Back to Services</Link>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content-section">
        <div className="container">
          <div className="service-details">
            <div className="details-section">
              <h2>Service Details</h2>
              <ul className="details-list">
                {service.details.map((detail, index) => (
                  <li key={index}>{detail}</li>
                ))}
              </ul>
            </div>

            <div className="features-section">
              <h2>Key Features</h2>
              <ul className="features-list">
                {service.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact Section */}
          <div className="contact-section">
            <h2>Get Started Today</h2>
            <p>Ready to take advantage of our {service.title.toLowerCase()} services? Contact us today for a consultation.</p>
            <div className="contact-buttons">
              <a href="tel:+9414050348" className="contact-btn primary">Call Now</a>
              <Link to="/contact" className="contact-btn secondary">Email Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetailPage;
